module.exports = __webpack_public_path__ + "assets/img/dc0d-ic.svg";